import { render } from "./AnalyticalData.vue?vue&type=template&id=5c977f24&scoped=true"
import script from "./AnalyticalData.vue?vue&type=script&lang=js"
export * from "./AnalyticalData.vue?vue&type=script&lang=js"

import "./AnalyticalData.vue?vue&type=style&index=0&id=5c977f24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c977f24"]])

export default __exports__